import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from './angular-material.module';

import { AbsValuePipe } from '../pipes/abs-value.pipe';
import { AppRoutingModule } from '@routing/app-routing.module';
import { BackNavigationComponent } from '../components/back-navigation/back-navigation.component';
import { SkeletonComponent } from '../components/skeleton/skeleton.component';
import { RmvLeadingZeroesPipe } from '../pipes/rmv-leading-zeroes.pipe';
import { NavbarComponent } from '../components/navbar/navbar.component';
import { LegSummaryComponent } from '../components/leg-summary/leg-summary.component';
import { CxlInfoComponent } from '../components/cxl-info/cxl-info.component';
import { DataBoxComponent } from '../components/data-box/data-box.component';
import { SabreTextDialogComponent } from '@shared/components/sabre-text-dialog/sabre-text-dialog.component';
import { UpdateDialogComponent } from '@shared/components/update-dialog/update-dialog.component';
import { DataStatusComponent } from '@shared/components/data-status/data-status.component';
import { TimePipe } from '@shared/pipes/time.pipe';
import { NavbarInstructionComponent } from '@shared/components/navbar-instruction/navbar-instruction.component';
import { BottomNavComponent } from '@shared/components/bottom-nav/bottom-nav.component';
import { PinnedHelpComponent } from '@shared/components/pinned-help/pinned-help.component';
import { BlurDirective } from '@shared/directives/blur.directive';
import { NoContactDialogComponent } from '@shared/components/no-contact-dialog/no-contact-dialog.component';
import { OpenPhoneDialogComponent } from '@shared/components/open-phone-dialog/open-phone-dialog.component';

@NgModule({
  declarations: [
    NavbarComponent,
    BottomNavComponent,
    NavbarInstructionComponent,
    BackNavigationComponent,
    SkeletonComponent,
    AbsValuePipe,
    RmvLeadingZeroesPipe,
    TimePipe,
    SabreTextDialogComponent,
    LegSummaryComponent,
    CxlInfoComponent,
    DataBoxComponent,
    UpdateDialogComponent,
    DataStatusComponent,
    PinnedHelpComponent,
    NoContactDialogComponent,
    OpenPhoneDialogComponent,
    BlurDirective,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    ReactiveFormsModule,
    AngularMaterialModule,
  ],
  exports: [
    AngularMaterialModule,
    NavbarComponent,
    BottomNavComponent,
    NavbarInstructionComponent,
    BackNavigationComponent,
    SkeletonComponent,
    AbsValuePipe,
    RmvLeadingZeroesPipe,
    TimePipe,
    SabreTextDialogComponent,
    LegSummaryComponent,
    CxlInfoComponent,
    DataBoxComponent,
    UpdateDialogComponent,
    DataStatusComponent,
    PinnedHelpComponent,
    NoContactDialogComponent,
    OpenPhoneDialogComponent,
    BlurDirective,
  ],
})
export class SharedModule {}
